module.exports = __webpack_public_path__ + "static/media/TN-Women-Knits-2.0.47eb9e9c.svg";